<button
  class="btn-secondary"
  (click)="click()"
  [disabled]="buttonDisabled">
  {{'data-integration.file.wizard.mapping.column.create-project' | translate}}
</button>
